import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMonitor = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2 4.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5h-4.434l-2.709-4.514a1 1 0 0 0-1.725.018l-3.073 5.378-1.665-3.33a1 1 0 0 0-1.788 0L3.382 9.5H2v-5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m13.547 10.023-1.526-2.544-3.153 5.517a1 1 0 0 1-1.762-.049L5.5 9.737l-.606 1.21A1 1 0 0 1 4 11.5H2v4a2 2 0 0 0 2 2h6.341a6.001 6.001 0 0 1 3.206-7.477Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M20 15.5c0 .742-.202 1.436-.554 2.032l2.261 2.261a1 1 0 0 1-1.414 1.414l-2.261-2.26A4 4 0 1 1 20 15.5Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcMonitor");

export { IcMonitor };
//# sourceMappingURL=ic-monitor.js.map
